import React from 'react';
import { observer } from 'mobx-react';
import { useParams, useHistory } from 'react-router-dom';
import { Typography, Button } from 'antd';
import { Trans } from 'react-i18next';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useStore } from '../../../../store/rootStore';
import ChannelNotification from '../../components/ChannelNotification';
import styles from './Details.module.scss';
import moment from 'moment';
import { isNotificationOfType } from '../../helpers';
const { Title, Text } = Typography;
const NotificationDetails = () => {
    const { id } = useParams();
    const { notificationsStore } = useStore();
    const history = useHistory();
    const notification = notificationsStore.getNotification(id);
    const goBack = () => {
        history.push('/');
    };
    if (!notification) {
        return (React.createElement("div", { className: styles.notFoundContainer },
            React.createElement(Title, { level: 4 },
                React.createElement(Trans, { i18nKey: "notificationNotFound" })),
            React.createElement(Button, { type: "primary", onClick: goBack },
                React.createElement(Trans, { i18nKey: "goToNotifications" }))));
    }
    return (React.createElement("div", { className: styles.details },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.titleContainer },
                React.createElement("div", { className: styles.withBackButton },
                    React.createElement(Button, { type: "text", icon: React.createElement(ArrowLeftOutlined, null), onClick: goBack, className: styles.backButton }),
                    React.createElement(Title, { level: 4, className: styles.title }, notification.title))),
            notification.date && React.createElement(Text, { type: "secondary" }, moment(notification.date).format('LLL'))),
        React.createElement("div", { className: styles.content },
            React.createElement(Text, null, notification.description)),
        isNotificationOfType(notification, 'channel') && (React.createElement(ChannelNotification, { notification: notification }))));
};
export default observer(NotificationDetails);
